module.exports = __webpack_public_path__ + "static/media/gray-close-ic.effacb3b.svg";